var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCleanedGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1176_5376",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "#DEA829"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1176_5376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5034 20.1282H4.48389C4.48389 19.5215 4.42343 18.9416 4.49876 18.3796C4.60086 17.6173 5.2214 17.1514 6.05605 17.1405C7.31001 17.1237 8.56495 17.1286 9.81891 17.1286C13.7642 17.1306 17.7084 17.1346 21.6537 17.1385C22.9443 17.1395 23.5123 17.7204 23.5034 19.0229C23.5014 19.3679 23.5034 19.7138 23.5034 20.1282Z",
    fill: "url(#paint0_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26281 16.098C6.26281 14.7301 6.24695 13.4454 6.27173 12.1617C6.27966 11.7345 6.62661 11.6631 6.98941 11.6641C8.90554 11.667 10.8207 11.6641 12.7368 11.6651C15.4122 11.6651 18.0877 11.6631 20.7631 11.669C21.6215 11.671 21.6899 11.7454 21.6979 12.6117C21.7068 13.6189 21.689 14.627 21.7108 15.6341C21.7187 16.0058 21.5888 16.1119 21.225 16.1149C20.0662 16.1248 20.0544 16.1387 20.0613 14.9779C20.0702 13.5366 20.0841 13.5832 18.6785 13.6C17.935 13.6089 17.1916 13.6099 16.4491 13.603C15.9901 13.599 15.783 13.824 15.7859 14.2701C15.7889 14.733 15.779 15.195 15.7959 15.6569C15.8058 15.9573 15.7314 16.1109 15.3855 16.104C14.4606 16.0861 13.5358 16.0891 12.6109 16.1069C12.262 16.1139 12.144 15.985 12.1569 15.645C12.1747 15.1672 12.1569 14.6874 12.1519 14.2087C12.148 13.8072 11.9537 13.599 11.5413 13.6C10.5342 13.603 9.52607 13.602 8.51894 13.602C8.08873 13.602 7.88156 13.8171 7.88453 14.2443C7.8875 14.7231 7.87263 15.2029 7.89543 15.6807C7.91129 16.0118 7.77945 16.1188 7.46225 16.102C7.08557 16.0822 6.7069 16.097 6.25984 16.097L6.26281 16.098Z",
    fill: "url(#paint1_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86643 23.0248C6.86643 23.741 6.86777 24.4292 6.86515 25.1079C6.86472 25.2217 6.84703 25.3837 6.83727 25.3864C6.73161 25.4065 6.62588 25.4011 6.52022 25.3998C6.21836 25.3971 5.91656 25.3864 5.61476 25.4025C5.58767 25.4038 5.57553 25.282 5.57858 24.6367C5.58102 24.1132 5.57907 23.5804 5.57907 23.0234H6.86655L6.86643 23.0248Z",
    fill: "url(#paint2_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6282 23.0248C22.6282 23.741 22.6295 24.4292 22.6269 25.1079C22.6264 25.2217 22.6088 25.3837 22.599 25.3864C22.4933 25.4065 22.3876 25.4011 22.2819 25.3998C21.9801 25.3971 21.6783 25.3864 21.3765 25.4025C21.3494 25.4038 21.3373 25.282 21.3403 24.6367C21.3427 24.1132 21.3408 23.5804 21.3408 23.0234H22.6283L22.6282 23.0248Z",
    fill: "url(#paint3_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9797 22.9719C10.6947 22.9719 7.41059 22.96 4.12651 22.9838C3.61105 22.9878 3.48714 22.8272 3.50102 22.3385C3.53175 21.1886 3.50796 21.1876 4.64098 21.1876C11.0119 21.1846 17.3818 21.1817 23.7527 21.1797C24.2159 21.1797 24.4446 21.4153 24.4386 21.8865C24.4257 22.962 24.4257 22.9689 23.3383 22.9709C20.2188 22.9749 17.0993 22.9719 13.9797 22.9719Z",
    fill: "url(#paint4_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65584 7.04736C7.3426 6.18198 6.98475 5.3959 5.90625 5.04499C6.97385 4.70994 7.32971 3.90899 7.62709 3C7.85509 3.46491 7.99287 3.89413 8.2516 4.23116C8.5014 4.55828 8.87411 4.79123 9.23494 5.1005C8.33189 5.38004 7.9671 6.17405 7.65584 7.04636V7.04736Z",
    fill: "url(#paint5_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4095 7.6802C20.2291 7.17961 20.0219 6.7266 19.3984 6.52339C20.015 6.33009 20.2212 5.86717 20.3927 5.3418C20.5245 5.61043 20.6038 5.85825 20.7535 6.05353C20.8982 6.24286 21.1133 6.37668 21.3215 6.5561C20.8001 6.71768 20.589 7.17565 20.4095 7.6802Z",
    fill: "url(#paint6_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3682 11.1552C22.1898 10.5198 21.9539 10.039 21.3125 9.80407C21.9588 9.57806 22.1898 9.08738 22.3484 8.5293C22.7264 9.20997 23.0786 9.64018 23.4051 9.81993C22.7766 10.0231 22.5615 10.5257 22.3692 11.1552H22.3682Z",
    fill: "url(#paint7_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1129 9.59441C16.9166 8.89854 16.6598 8.37317 15.957 8.11543C16.6648 7.86762 16.9176 7.33035 17.091 6.71973C17.5054 7.46516 17.891 7.93635 18.2479 8.13328C17.5599 8.35631 17.324 8.90647 17.1138 9.59441H17.1129Z",
    fill: "url(#paint8_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2677 10.1147C11.0545 9.35836 10.775 8.78739 10.0117 8.50785C10.7809 8.23823 11.0555 7.65536 11.2439 6.99121C11.6939 7.80075 12.1129 8.31257 12.5008 8.52669C11.7534 8.76856 11.4976 9.36629 11.2686 10.1147H11.2677Z",
    fill: "url(#paint9_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1345 6.75857C14.0146 6.33133 13.857 6.01016 13.4258 5.85156C13.86 5.6999 14.0146 5.37079 14.1207 4.99609C14.3744 5.45274 14.6107 5.74153 14.8294 5.86246C14.4071 5.99926 14.2634 6.33629 14.1335 6.75857H14.1345Z",
    fill: "url(#paint10_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60725 10.9217C6.4199 10.2546 6.17307 9.75202 5.5 9.50519C6.17803 9.26828 6.4199 8.75282 6.58544 8.16797C6.98195 8.88168 7.35136 9.33304 7.69368 9.52204C7.03449 9.73517 6.80848 10.2625 6.60725 10.9217Z",
    fill: "url(#paint11_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1062 14.6192V16.0952C10.4321 16.0952 9.78181 16.1021 9.13154 16.0863C9.05521 16.0843 8.92139 15.9624 8.91743 15.889C8.89661 15.546 8.89562 15.1991 8.92536 14.8571C8.9323 14.7719 9.079 14.6321 9.16425 14.6291C9.79966 14.6093 10.437 14.6182 11.1062 14.6182V14.6192Z",
    fill: "url(#paint12_linear_1176_5376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0413 16.0785H16.8228C16.8228 15.6652 16.801 15.2746 16.8377 14.889C16.8466 14.7899 17.033 14.6342 17.144 14.6283C17.6714 14.6025 18.2017 14.6045 18.7281 14.6342C18.8371 14.6402 19.0165 14.7998 19.0274 14.9019C19.0641 15.2746 19.0413 15.6523 19.0413 16.0785Z",
    fill: "url(#paint13_linear_1176_5376)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1176_5376",
    x1: 13.9822,
    y1: 17.1279,
    x2: 13.9822,
    y2: 20.1282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1176_5376",
    x1: 13.9845,
    y1: 11.6641,
    x2: 13.9845,
    y2: 16.1168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1176_5376",
    x1: 6.22245,
    y1: 23.0234,
    x2: 6.22245,
    y2: 25.4025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1176_5376",
    x1: 21.9842,
    y1: 23.0234,
    x2: 21.9842,
    y2: 25.4025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1176_5376",
    x1: 13.9694,
    y1: 21.1797,
    x2: 13.9694,
    y2: 22.9839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1176_5376",
    x1: 7.57059,
    y1: 3,
    x2: 7.57059,
    y2: 7.04736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1176_5376",
    x1: 20.36,
    y1: 5.3418,
    x2: 20.36,
    y2: 7.6802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1176_5376",
    x1: 22.3588,
    y1: 8.5293,
    x2: 22.3588,
    y2: 11.1552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1176_5376",
    x1: 17.1024,
    y1: 6.71973,
    x2: 17.1024,
    y2: 9.59441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1176_5376",
    x1: 11.2563,
    y1: 6.99121,
    x2: 11.2563,
    y2: 10.1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1176_5376",
    x1: 14.1276,
    y1: 4.99609,
    x2: 14.1276,
    y2: 6.75857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1176_5376",
    x1: 6.59684,
    y1: 8.16797,
    x2: 6.59684,
    y2: 10.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1176_5376",
    x1: 10.0042,
    y1: 14.6162,
    x2: 10.0042,
    y2: 16.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1176_5376",
    x1: 17.9324,
    y1: 14.6104,
    x2: 17.9324,
    y2: 16.0785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEA829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanedGold);
export default __webpack_public_path__ + "static/media/cleaned_gold.a4ac3175c4d28d2c6d3301a52783e1d6.svg";
export { ForwardRef as ReactComponent };